import React, { useContext, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { get, isEmpty } from "lodash";
import { ManageMapperMenu } from "../../../components";
import { withAppLayout } from "../../../hoc";
import {
  manageMapperFormNames,
  MANAGE_MAPPER_MENU,
  MANAGE_MAPPER_MENU_WITH_OVERVIEW,
  FLOW_TYPES,
  MANAGE_MAPPER_MENU_OUTPUT,
  MANAGE_MAPPER_ROUTES,
  MANAGE_MAPPER_MENU_PASSTHROUGH,
} from "../../../utils";
import { ManageMapperRoutes } from "../../../routes";
import {
  manageMapperStore,
  ManageMapperProvider,
  setManageMapperSelectedMenu,
} from "../../../contexts";
import AddToolTip from "../../../components/AddToolTip";

export const Mapper = (props) => {
  const { location } = props;
  const { state, dispatch } = useContext(manageMapperStore);
  const mapType = get(state, "api.data.mapType");
  //const isFixedLength = get(state, "api.fileuploadData.mappingConfiguration.format", 3)?get(state, "api.fileuploadData.mappingConfiguration.format", 3):get(state, "api.data.format", 3) === 2;
  const isFetching = get(state, "api.isFetching", {});
  const profileId = get(state, "api.data.id");
  const flow = get(state, "flow");
  const data = get(state, "api.data", {});
  const profileName = !isEmpty(data) && get(data, "name");
  const sourceData = get(state, "load_definition_source", []);
  const basicInformation = get(state, "basicInformation", []);
  const InputOutputFormValues = get(state, "api.fileuploadData", "")
    ? get(state, "api.fileuploadData.mappingConfiguration", {})
    : get(state, "api.data", {});
  const formValues = InputOutputFormValues;
  // const fileInfo = get(state, "api.fileuploadData", {})
  //   ? get(state, "api.fileuploadData.mappingConfiguration", {})
  //   : get(state, "api.data", {});
  const isFixedLength = formValues.format === 2;
  const editable = formValues.step;
  useEffect(() => {
    dispatch(setManageMapperSelectedMenu(location.pathname));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const mapperName = get(
    state,
    `${manageMapperFormNames.MAP_AND_TRANSFORM}.mapperName`,
    ""
  );

  const isLoading = flow === FLOW_TYPES.ADD ? false : isFetching;
  const isEdit = flow === FLOW_TYPES.EDIT;

  const getMapperMenu = () => {
    if (mapType == 1) {
      return isEdit ? MANAGE_MAPPER_MENU_WITH_OVERVIEW : MANAGE_MAPPER_MENU;
    } else if (mapType == 2 || get(data, "isOutput", false)) {
      return isEdit
        ? [
            {
              id: "overview",
              label: "Overview",
              contentHeader: "Overview",
              path: MANAGE_MAPPER_ROUTES.OVERVIEW,
              breadCrumbs: [],
              childRoutes: [],
            },
            ...MANAGE_MAPPER_MENU_OUTPUT,
          ]
        : [
            ...MANAGE_MAPPER_MENU_OUTPUT,
            {
              id: "reviewAndConfirm",
              label: "Review & Confirm",
              path: MANAGE_MAPPER_ROUTES.REVIEW_AND_CONFIRM,
              contentHeader: "Review & Confirm",
              breadCrumbs: [],
              childRoutes: [],
            },
          ];
    } else if (mapType == 3) {
      return isEdit
        ? [
            {
              id: "overview",
              label: "Overview",
              contentHeader: "Overview",
              path: MANAGE_MAPPER_ROUTES.OVERVIEW,
              breadCrumbs: [],
              childRoutes: [],
            },
            ...MANAGE_MAPPER_MENU_PASSTHROUGH,
          ]
        : MANAGE_MAPPER_MENU_PASSTHROUGH;
    } else {
      return isEdit ? MANAGE_MAPPER_MENU_WITH_OVERVIEW : MANAGE_MAPPER_MENU;
    }
  };

  return (
    <div className="row manage-company-wrapper m-0">
      <Col className="h-100">
        <Row sm="12" className="h-100">
          <Col className="manage-company-column manage-mapper-menu-items">
            <div className="company-name-component">
              {mapperName && (
                <div>
                  <div className="heading">Mapper</div>
                  <div>
                    <h6>{mapperName}</h6>
                  </div>
                </div>
              )}
              {profileName && (
                <div>
                  <div className="heading">Profile Name</div>
                  <div>
                    <AddToolTip name={profileName}>
                      <h6
                        className="text-overflow-elipsis"
                        style={{ width: "150px" }}
                      >
                        {profileName}
                      </h6>
                    </AddToolTip>
                  </div>
                </div>
              )}
            </div>
            <ManageMapperMenu
              linkDisable={editable} //true
              menuList={getMapperMenu()}
              selectedMenu={get(state, "selectedMenu")}
              flow={flow}
              profileId={profileId}
              isFixedLength={isFixedLength}
              mapType={mapType}
              isEdit={isEdit}
              isOutput={formValues?.isOutput}
            />
          </Col>
          <Col className="h-100 manage-menu-content w-50">
            <ManageMapperRoutes mapperName={mapperName} />
          </Col>
        </Row>
      </Col>
    </div>
  );
};

const ManageMapperWithProvider = (props) => {
  return (
    <ManageMapperProvider>
      <Mapper {...props} />
    </ManageMapperProvider>
  );
};

export default withAppLayout(ManageMapperWithProvider);
